export enum TOKEN {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
}

export enum STATUS {
  LOADING = 'loading',
  IDLE = 'idle',
  FAILED = 'failed',
}

export enum NOTIFICATION {
  LOGGED_IN = 'Logged in',
  WRONG_CREDENTIALS = 'Wrong credentials',
  UPDATED = 'Updated',
  NOT_UPDATED = 'Not updated',
  CREATED = 'Created',
  NOT_CREATED = 'Not created!',
  NOT_DELETED = 'Not deleted',
  NOT_EDITED = 'Not edited',
  SUCCESSFUL_MESSAGE_CHANGE = 'Message successfully changed',
  SUCCESSFUL_NAME_CHANGE = 'Name successfully changed',
  SOMETHING_WENT_WRONG = 'Something went wrong',
  FILE_UPLOADED = 'File uploaded',
  FILE_NOT_UPLOADED = 'File not uploaded',
  SAVED = 'Saved',
  DELETED = 'Avatar deleted',
  USER_DELETED = 'User removed from organisation',
  EMPTY = "Input can't be empty",
  TRANSCODING_STARTED = 'Processing started!',
  TRANSCODING_FINISHED = 'Processing finished!',
  NAME_ALREADY_EXISTS = 'Subgroup with that name already exists',
  GROUP_NAME_ALREADY_EXISTS = 'Group with that name already exists',
  CLIPS_COUNT_SHOULD_BE_LESS_OR_EQUAL_4 = 'The number of angles should be less than or equal to 4',
  MULTIPLE_VIDEO_GROUPS = 'No more than one movie collection should be present in package',
  TOO_MANY_MOVIE_PARTS = 'Unable to upload due to too many movie parts',
  AMBIGUOUS_PACKAGE = 'Package should not contain more than one timeline or composer',
}

export enum SHARE_TYPE {
  USER = 'user',
  GROUP = 'group',
}

export enum GROUP_TYPE {
  GROUP = 'GROUP',
  SUBGROUP = 'SUBGROUP',
}

export enum FILE_SIZES {
  KB = 1000,
  MB = 1000 * KB,
  GB = 1000 * MB,
}

export enum COMMENT_PARENT_TYPE {
  CLIP = 'clip',
  VIDEOFEED = 'videofeed',
  COMMENT = 'comment',
}

export enum TRANSCODING_STATUS {
  DEFAULT = 'default',
  IN_PROGRESS = 'in_progress',
  FINISHED = 'finished',
}

export enum TRANSCODING_EVENTS {
  STARTED = 'started',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export enum VIDEOFEED_TYPE {
  TIMELINE = 'TIMELINE',
  COMPOSER = 'COMPOSER',
  MY_COMPOSER = 'MY_COMPOSER',
  REFLEX_COMPOSER = 'composer',
  ONLINE_COMPOSER = 'online_composer',
}

export enum FOLDER_CONTENT_FILTER {
  ALL = 'all',
  TIMELINE = 'timeline',
  COMPOSER = 'composer',
  SUBFOLDER = 'subfolder',
}

export enum VIDEOPAGE_TYPE {
  COMPOSER = 'COMPOSER',
  TIMELINE = 'TIMELINE',
  MY_COMPOSER = 'MY_COMPOSER',
}

export enum VIDEOFEED_STATUS {
  CREATED = 'CREATED',
  UPLOADING = 'UPLOADING',
  UPLOADED = 'UPLOADED',
  UNZIPPING = 'UNZIPPING',
  UNZIPPED = 'UNZIPPED',
  TRANSCODING = 'TRANSCODING',
  TRANSCODING_FAILED = 'TRANSCODING_FAILED',
  METADATA_UPLOADING = 'METADATA_UPLOADING',
  METADATA_PROCESSING = 'METADATA_PROCESSING',
  METADATA_FAILED = 'METADATA_FAILED',
  METADATA_DONE = 'METADATA_DONE',
  DONE = 'DONE',
}

export enum UPLOAD_TYPE {
  STANDALONE = 'standalone',
  PACKAGE = 'package',
}

export enum SHARED_CONTENT_ENUM {
  SHARED_COMPOSER = 'shared_composer',
  SHARED_ONLINE_COMPOSER = 'shared_online_composer',
  SHARED_TIMELINE = 'shared_timeline',
  SHARED_FOLDER = 'shared_folder',
}
